import { useEffect, useRef, useState } from 'react';
import {
  createGroup,
  editGroup,
  getGroup,
  IGroupMember,
} from '../../services/groupService';
import { v4 as uuid } from 'uuid';
import { useSetAtom } from 'jotai';
import { successMessageAtom } from '../../atoms/messageBarAtoms';
import { Field, makeStyles } from '@fluentui/react-components';
import { EditItem, PagedDataGrid, type IPagedDataGridRefType } from '@moko/ui';

const useStyles = makeStyles({
  root: {
    width: '350px',
  },
});

const Group = () => {
  const isSaved = useRef(false);
  const setSuccessMessage = useSetAtom(successMessageAtom);
  const styles = useStyles();
  const [groupMembers, setGroupMembers] = useState<any[]>([]);
  const membersGridRef = useRef<IPagedDataGridRefType | null>(null);

  useEffect(() => {
    membersGridRef.current?.refresh();
  }, [groupMembers]);

  return (
    <>
      <div>Group</div>
      <EditItem
        getAction={async (abortController, id) => {
          const group: any = await getGroup(abortController, id);
          setGroupMembers(group.users ?? group.members ?? []);
          return group;
        }}
        newAction={async (abortController, newGroup) => {
          const newGroupResponse = await createGroup(abortController, {
            name: newGroup.name,
          });
          setSuccessMessage(
            `Group with id: ${newGroupResponse.groupId} created.`
          );
        }}
        editAction={async (abortController, id, editedGroup) => {
          await editGroup(abortController, id, {
            name: editedGroup.name,
          });
          setSuccessMessage(`Group with id: ${id} successfully updated.`);
        }}
        isSaved={isSaved}
        back={'/security?tab=groups'}
        defaultValues={JSON.stringify({ uuid: uuid() })}
        metadata={{
          fields: [
            {
              name: 'name',
              fieldType: 'String',
              label: 'Name',
            },
          ],
          lookups: [],
          validations: [],
          interactions: [],
        }}
      >
        <Field label="Members" className={styles.root}>
          <PagedDataGrid<IGroupMember>
            ref={membersGridRef}
            columns={[
              { key: 'id', name: 'Id', minWidth: 40, width: 60 },
              { key: 'userName', name: 'Name' },
            ]}
            getAction={async (_abortController, _pageSize, _pageNo) => {
              return Promise.resolve({
                isLastPage: true,
                items: groupMembers,
                pageCount: 1,
                pageNo: 1,
                pageSize: 10,
                rowsCount: groupMembers.length,
              });
            }}
            searchable={false}
          />
        </Field>
      </EditItem>
    </>
  );
};

export default Group;
